import React, { useState, useEffect } from "react";
import "../../components/Charges/Charges.css";

const Charges = () => {
  return (
    <div className="container-fluid">
      <br />

      <div className="chargesDetail">
        <form className="charges-form">
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Description*</td>
              <td>Quantity</td>
              <td>Selling Ex-GST</td>
            </tr>

            <tr>
              <td>
                <input placeholder="Enter Please" />
              </td>
              <td>
                <input placeholder="Enter Please" />
              </td>
              <td>
                <input placeholder="Enter Please" />
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Delivery Charges</td>
              <td>Height</td>
            </tr>

            <tr>
              <td>
                <input placeholder="Enter Please" />
              </td>
              <td>
                <input placeholder="Enter Please" />
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Selling Ex-GST</td>
              <td>Delivery Charges</td>
            </tr>

            <tr>
              <td>
                <input placeholder="Enter Please" />
              </td>
              <td>
                <input placeholder="Enter Please" />
              </td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addCharges-button">
            <button
              type="submit"
              style={{
                marginRight: "10px",
                backgroundColor: "#5B489D",
                color: "white",
              }}
            >
              Apply
            </button>
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
          </div>
        </form>
      </div>
      <br />
    </div>
  );
};

export default Charges;
